// frontend\src\services\authService.js
import api from './apiService';
import axios from 'axios';

// --- DETECÇÃO INTELIGENTE DE URL ---
let API_BASE_URL;
if (window.location.hostname.includes('saldoativo.com.br')) {
    API_BASE_URL = 'https://api.saldoativo.com.br';
} else {
    // Dinâmico: Se acessado por IP (ex: 192.168.x.x), usa esse mesmo IP para o backend
    API_BASE_URL = `http://${window.location.hostname}:8000`;
}

export const login = async (email, password) => {
    const response = await api.post('auth/login/', { email, password });
    return response.data;
};

export const register = async (userData) => {
    const response = await api.post('auth/registration/', userData);
    return response.data;
};

/** Confirma e-mail com a chave recebida no link do e-mail (cadastro "Criar conta"). */
export const confirmarEmail = async (key) => {
    const response = await api.post('auth/registration/verify-email/', { key });
    return response.data;
};

/** Reenvia o e-mail de confirmação do cadastro (responde igual se o e-mail não existir). */
export const reenviarConfirmacaoEmail = async (email) => {
    const response = await api.post('auth/registration/resend-email/', { email });
    return response.data;
};

export const loginWithGoogle = async (accessToken, ref, origem) => {
    const payload = { access_token: accessToken };
    if (ref) payload.ref = ref;
    if (origem) payload.origem = origem;
    const response = await api.post('auth/google/', payload);
    return response.data;
};

export const getPerfil = async () => {
    const response = await api.get('auth/user/');
    return response.data;
};

export const updatePerfil = async (profileData) => {
    const response = await api.patch('auth/user/', profileData);
    return response.data;
};

export const getUserDetails = async () => {
    return getPerfil();
};

// --- FUNÇÕES DE ONBOARDING ---
export const validarTokenOnboarding = async (token) => {
    const response = await axios.get(`${API_BASE_URL}/onboarding/definir-senha/${token}/`);
    return response.data;
};

export const definirSenhaOnboarding = async (token, password, password_confirmation) => {
    const response = await axios.post(`${API_BASE_URL}/onboarding/definir-senha/${token}/`, { password, password_confirmation });
    return response.data;
};

// --- NOVAS FUNÇÕES: ESQUECI MINHA SENHA ---

export const solicitarResetSenha = async (email) => {
    // 1. Define a URL base do Frontend dinamicamente
    let frontendBaseUrl;
    if (window.location.hostname.includes('saldoativo.com.br')) {
        frontendBaseUrl = 'https://app.saldoativo.com.br';
    } else {
        frontendBaseUrl = 'http://localhost:3000';
    }

    // 2. Constrói a URL para onde o usuário deve voltar após clicar no e-mail
    const redirectUrl = `${frontendBaseUrl}/password-reset/confirm`;

    // 3. Envia para o backend (o backend precisa do redirect_url para montar o link)
    const response = await api.post('auth/password/reset/', {
        email,
        redirect_url: redirectUrl
    });
    return response.data;
};

export const getDadosFinanceirosAfiliado = async () => {
    const response = await api.get('afiliados/dados-financeiros/');
    return response.data;
};

export const salvarDadosFinanceirosAfiliado = async (dados) => {
    const response = await api.post('afiliados/dados-financeiros/', dados);
    return response.data;
};

export const getPainelAfiliado = async () => {
    const response = await api.get('afiliados/painel/');
    return response.data;
};

export const getIndicacoesAfiliado = async (params = {}) => {
    const response = await api.get('afiliados/indicacoes/', { params });
    return response.data;
};

export const confirmarResetSenha = async (uid, token, newPassword1, newPassword2) => {
    const response = await api.post('auth/password/reset/confirm/', {
        uid,
        token,
        new_password1: newPassword1,
        new_password2: newPassword2,
    });
    return response.data;
};

export const alterarSenha = async (oldPassword, newPassword1, newPassword2) => {
    const response = await api.post('auth/password/change/', {
        old_password: oldPassword,
        new_password1: newPassword1,
        new_password2: newPassword2,
    });
    return response.data;
};

const authService = {
    login,
    loginWithGoogle,
    register,
    confirmarEmail,
    reenviarConfirmacaoEmail,
    getDadosFinanceirosAfiliado,
    salvarDadosFinanceirosAfiliado,
    getPerfil,
    updatePerfil,
    getUserDetails,
    validarTokenOnboarding,
    definirSenhaOnboarding,
    solicitarResetSenha,
    confirmarResetSenha,
    alterarSenha,
};

export default authService;